import {Component, computed, inject, Signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {ValidationErrorsComponent} from '../../../../../common/validation-errors/validation-errors.component';
import {SpinnerComponent} from '../../../../../common/spinner/spinner.component';
import {AccordionGroupComponent} from '../../../../../common/accordion-group/accordion-group.component';
import {AccordionItemComponent} from '../../../../../common/accordion-item/accordion-item.component';
import {SubpageContentByUrlPipe} from '../../../../../pipes/subpage-content-by-url.pipe';
import {AgreementForm} from './forms/agreement.form';
import {ApplicationAppEntityApplicationRead, SubpageAppEntitySubpageRead} from '../../../../../openapi';
import {selectSubpages} from '../../../../../store/selectors/app.selectors';
import {updateApplication} from '../../../../../store/actions/application.actions';
import {StagesComponent} from '../../../../../common/stages/stages.component';
import {ApplicationCommonComponent} from '../application.common.component';

export interface AgreementsDataComponentConfig {
  stages: string[];
  successUrl: string;
  cancelUrl: string;
  removeClauseControl?: boolean;
  removeRegulationsControl?: boolean;
}

@Component({
  selector: 'app-agreements-data-section',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    SpinnerComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    SubpageContentByUrlPipe,
    StagesComponent
  ],
  providers: [
    AgreementForm
  ],
  templateUrl: './agreements-data-section.component.html'
})
export class AgreementsDataSectionComponent extends ApplicationCommonComponent {

  public successUrl: string | undefined = this.route.snapshot.data['successUrl'];

  public cancelUrl: string | undefined = this.route.snapshot.data['cancelUrl'];

  public stages: string[] = this.route.snapshot.data['stages'];

  public rodoContent: Signal<string | null> = computed(() => this.application()?.service?.gdpr || null);

  public subpages: Signal<SubpageAppEntitySubpageRead[]> = this.store$.selectSignal(selectSubpages);

  public form: AgreementForm = inject(AgreementForm);

  public get sectionTitle(): string {
    switch (true) {
      case !!this.form.regulations && !!this.form.clause: {
        return 'Zapoznaj się z regulaminem oraz klauzulą';
      }
      case !!this.form.clause: {
        return 'Zapoznaj się z klauzulą';
      }
      case !!this.form.regulations: {
        return 'Zapoznaj się z regulaminem';
      }
      default: {
        return '';
      }
    }
  }

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchValue(app);
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        successFnc: () => {
          this.router.navigate([this.successUrl], {relativeTo: this.route});
        },
        failureFnc: () => {
        },
        application: this.form.toWriteModel(),
        id: this.applicationId || ''
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public override onCancel(): void {
    this.router.navigate([this.cancelUrl], {relativeTo: this.route});
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    if (this.route.snapshot.data['removeClauseControl']) {
      this.form.removeControl('clause');
    }
    if (this.route.snapshot.data['removeRegulationsControl']) {
      this.form.removeControl('regulations');
    }
  }
}
